import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, FormGroupDirective, NgForm} from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';
import {Router} from '@angular/router';
import {CaexService} from 'src/app/services/caex.service';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-caex-member',
  templateUrl: './caex-member.component.html',
  styleUrls: [ './caex-member.component.scss' ]
})
export class CaexMemberComponent implements OnInit {

  public spinner: boolean;
  public memberForm: FormGroup;
  public matcher = new FormErrorStateMatcher();

  public subCategories: any[] = []
  public subCategorySelected: any = {};

  constructor (
    public _caexService: CaexService,
    private router: Router,
    private snackBar: SnackBarIconService,
  ) {

    if (!this._caexService.currentMember) {
      this.router.navigate([ 'caex' ]);
    }

    this.loadSubCategories()

    this.memberForm = this._caexService.createMemberForm()
    this._caexService.setMemberFormData(this.memberForm, this._caexService.currentMember)

  }

  ngOnInit () {
  }

  subCategorySelectedChange (id) {

    this.subCategorySelected = this.subCategories.find((e) => {
      return e.id == id
    })
    //  console.log(JSON.stringify(this.subCategorySelected))
  }

  loadSubCategories () {
    //this._subcategoryService.selectSubcategories(true)
    this._caexService.selectSubcategoriesCaex()
      .subscribe((result) => {
        result.forEach((item) => {

          this.subCategories.push({
            'id': item.payload.doc.id,
            'name': item.payload.doc.data().name,
            'documents': item.payload.doc.data().documents,
            'documents_en': item.payload.doc.data().documents_en,
            'hidden': item.payload.doc.data().hidden,
            'partner': item.payload.doc.data().partner,
            'sponsor': item.payload.doc.data().sponsor,
            'front_desk': item.payload.doc.data().front_desk,
          })

        })

      })
  }

  getSubscriptions () {
    // this._caexService.currentMember = this._caexService.currentMember;

    this.router.navigate([ 'caex-orders' ]);
  }

  updateMember () {

    if (this.memberForm.valid) {
      this.spinner = false;

      let member = this.memberForm.getRawValue()

      let subCategory: any = this.subCategories.find((e) => {
        return e.id == member.subCategory_id
      })

      delete subCategory.documents
      delete subCategory.documents_en
      delete subCategory.front_desk
      delete subCategory.sponsor

      member.subCategory = subCategory

      delete member.subCategory_id

      member.cellPhone = member.cellPhone
        .replace("(", "")
        .replace(")", "")
        .replace("-", "")
        .replace(" ", "")
        .trim()

      member.cpf = member.cpf
        .replace(".", "")
        .replace(".", "")
        .replace(".", "")
        .replace("-", "")
        .trim()

      // console.log("member: " + JSON.stringify(member))

      this._caexService.updateMember(member)
        .then(() => {

          this._caexService.currentMember.name = member.name
          this._caexService.currentMember.email = member.email
          this._caexService.currentMember.cellPhone = member.cellPhone
          this._caexService.currentMember.cellPhonePrefix = member.cellPhonePrefix
          this._caexService.currentMember.cpf = member.cpf
          this._caexService.currentMember.subCategory_id = member.subCategory_id
          this._caexService.currentMember.crm = member.crm

          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch(() => {
          console.log("error on update member")
          this.snackBar.openSnackBar("Erro ao atualizar", '', 'error');
        })
        .finally(() => {
          this.spinner = false;
        })

    }

  }

  goBack () {
    this.router.navigate([ 'caex' ]);
  }

}

